<script setup lang="ts">
import type { HierarchicalMenuItem } from '~/types/searchSidebar'

defineProps<{
    items: HierarchicalMenuItem[]
    refine: (value: string) => void
    depth?: number
}>()
</script>

<template>
    <ul v-if="!depth">
        <li v-for="item in items" :key="item.value">
            <button
                type="button"
                class="block py-2 text-sm w-full text-left cursor-pointer"
                @click="refine(item.value)"
            >
                <span
                    class="block font-semibold leading-6 hover:text-neutral"
                    :class="item.isRefined ? 'text-base-content' : 'text-base-content-subtle'"
                >
                    {{ item.label }}
                </span>
            </button>

            <SearchSidebarMeiliCategory
                v-if="item.isRefined && item.data?.length"
                :items="item.data"
                :refine="refine"
                :depth="1"
            />
        </li>
    </ul>

    <ul v-else class="pl-4 py-2">
        <li v-for="item in items" :key="item.value">
            <button
                type="button"
                class="block py-1 w-full text-left cursor-pointer text-base-content-subtle hover:text-neutral"
                :class="{ 'active text-neutral font-semibold': item.isRefined }"
                @click="refine(item.value)"
            >
                <span class="rounded-[1px] text-sm leading-6 block">
                    {{ item.label }}
                </span>
            </button>

            <SearchSidebarMeiliCategory
                v-if="item.isRefined && item.data?.length"
                :items="item.data"
                :refine="refine"
                :depth="depth + 1"
            />
        </li>
    </ul>
</template>
